import {useQuery} from '@tanstack/react-query';

import {RQ_SEARCH_FILTER_API} from './constants';
import {rqCreateRequest} from './rqHttpUtils';

export const RqSearchFilteredProducts = (token, filters) => {
  return useQuery({
    queryKey: ['filteredProducts', filters],

    queryFn: () =>
      rqCreateRequest(
        {
          ...RQ_SEARCH_FILTER_API,
          url: RQ_SEARCH_FILTER_API.url,
        },
        filters, 
        token,
      ),
    
  });
};
